export default "__VITE_ASSET__BBd864HJ__"